<template>
  <KeepAlive>
    <component :is="tableType" :channel="channel" :recurrentAddOns="recurrentAddOns" :key="key"></component>
  </KeepAlive>
</template>

<script>
export default {
  name: 'TableBalancerecurrentAddOns',
  components: {
    TableBalanceRecurringEmail: () => import('./TableBalanceRecurringEmail.vue'),
    TableBalanceRecurringSMS: () => import('./TableBalanceRecurringSMS.vue'),
  },
  props: {
    recurrentAddOns: {
      type: Array,
      default: () => {},
    },
    channel: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      key: null,
    }
  },

  created() {
    this.key = Math.floor(Math.random() * 100) + 1
  },

  beforeDestroy() {
    this.$root.$off('update-close-popup')
  },

  computed: {
    tableType() {
      return this.channel == 'email' ? 'TableBalanceRecurringEmail' : 'TableBalanceRecurringSMS'
    },
  },
}
</script>

<style lang="scss" scope></style>
